import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { LogEntry } from './log.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ClaEvents, ClaStorage} from "../../model/events";
import {Events} from "ionic-angular";

export abstract class LogPublisher {
  logLocation: string;
  clearLocation: string;
  baseUrl: string;
  maxFileSize: number = 1024 * 1024 * 100; // 100MB
  abstract log(record: LogEntry):
    Observable<boolean>
  abstract clear(): Observable<boolean>;
  abstract sendToCloud(practiceId: string): Observable<boolean>;
}

const logInternal= (message: string) => {
  // Log to console
  if(window["com"] && window["com"].synapse && window["com"].synapse.oldConsoleLog) {
    window["com"].synapse.oldConsoleLog(message);
  } else {
    console.log('Old console log not found, using default console.log');
    console.log(message);
  }
}

export class LogConsole extends LogPublisher {

  log(entry: LogEntry): Observable<boolean> {
    // Log to console
    logInternal(entry.buildLogString());
    return Observable.of(true);
  }



  clear(): Observable<boolean> {
    return Observable.of(true);
  }

  sendToCloud(practiceId: string): Observable<boolean> {
    return Observable.of(true);
  }
}

export class LogLocalStorage extends LogPublisher {
  public cloudApiUrl = 'https://synapse-debug-store.azurewebsites.net/api/store/';

  constructor(private http: HttpClient, private events: Events) {
    // Must call `super()`from derived classes
    // @ts-ignore
    super();

    // Set location
    this.logLocation = "logging";
  }

  // Append log entry to local storage
  log(entry: LogEntry): Observable<boolean> {
    let ret: boolean = false;
    let values: LogEntry[];

    try {
      // Get previous values from local storage
      values = JSON.parse(localStorage.getItem(this.logLocation)) || [];

      // Add new log entry to array
      values.push(entry);

      // check file size
      if(this.checkFileSize() > this.maxFileSize) {
        // Remove first 10% of the log
        values = values.slice(values.length/10);
      }

      // Store array into local storage
      localStorage.setItem(this.logLocation, JSON.stringify(values));

      // Set return value
      ret = true;
    } catch (ex) {
      // Display error in console
      logInternal(JSON.stringify(ex));
    }

    return Observable.of(ret);
  }

  checkFileSize():number {
    let logFile = localStorage.getItem(this.logLocation);
    return logFile ? 3 + (logFile.length*16)/(8*1024) : 0;
  }

  // Clear all log entries from local storage
  clear(): Observable<boolean> {
    localStorage.setItem(this.logLocation, '');
    localStorage.removeItem(this.logLocation);
    return Observable.of(true);
  }

  sendToCloud(practiceId: string): Observable<boolean> {
    var logs = localStorage.getItem(this.logLocation);
    var url = `${this.cloudApiUrl}${practiceId}`;
    if (logs) {
      // Send logs to cloud
      logInternal('Sending logs to cloud');
      this.http
        .post(url, logs)
        .subscribe(() => {
            this.events.publish(ClaEvents.LOGS_SENT);
          logInternal('Logs sent to cloud');
            this.clear().subscribe(() => logInternal('Logs cleared'));
          }, error => {
              let err = error as HttpErrorResponse;
              console.error('api.login', url, err.message, err.error);
          });
    }
    return Observable.of(true);
  }
}

export class LogWebApi extends LogPublisher {
  constructor(private http: HttpClient) {
    // Must call `super()`from derived classes
    super();

    // Set location
    this.logLocation = "/api/log";
    this.clearLocation = "/api/clear";
    this.baseUrl = "http://localhost:5000";
  }

  // Add log entry to back end data store
  log(entry: LogEntry): Observable<boolean> {
    return this.http.post(`${this.baseUrl}${this.logLocation}`, entry).catch(this.handleErrors);
  }

  // Clear all log entries from local storage
  clear(): Observable<boolean> {
    this.http.get(`${this.baseUrl}${this.clearLocation}`).catch(this.handleErrors);
    return Observable.of(true);
  }

  sendToCloud(practiceId: string): Observable<boolean> {
    return Observable.of(true);
  }

  private handleErrors(error: any): Observable<any> {
      let errors: string[] = [];
    let msg: string = "";

    msg = "Status: " + error.status;
    msg += " - Status Text: " + error.statusText;
    if (error.json()) {
      msg += " - Exception Message: " + error.json().exceptionMessage;
    }
    errors.push(msg);

    console.error('An error occurred', errors);
    return Observable.throw(errors);
  }

}



// WEBPACK FOOTER //
// ./src/providers/logging/log-publishers.ts